export const state = {
  filterRole: {
    name: "",
    status: [],
    isFilter: false,
  },
};

export const mutations = {
  ADD_FILTER_ROLE: (state, data) => {
    state.filterRole = data;
    state.filterRole.isFilter = true;
  },
  CLEAR_FILTER_ROLE: (state) => {
    state.filterRole = {
      name: "",
      status: [],
    };
  },
};
export const getters = {
  GET_FILTER_ROLE: (state) => {
    // console.log("GET_FILTER_ROLE", state.filterRole);
    return state.filterRole;
  },
};
export const actions = {
  ADD_FILTER_ROLE: ({ commit }, data) => {
    commit("ADD_FILTER_ROLE", data);
  },
  CLEAR_FILTER_ROLE: ({ commit }) => {
    commit("CLEAR_FILTER_ROLE");
  },
};
